export default __webpack_public_path__ + "static/git-396a5b09533ba7efb6af22db1656cfe6.png";